import React from 'react';
import useFeature from "../../useFeature";
import {CheckingAccountFeature} from "./CheckingAccountFeature";
import {TICKETS_PATH} from "../../routes";
import {observer} from "mobx-react";
import {useApplication} from "../../ApplicationProvider";
import {useNavigate} from "react-router-dom";
import MoneyRenderer from "../utils/MoneyRenderer";
import {Skeleton} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const CheckingAccountScreen = () => {
    const application = useApplication();
    const navigator = useNavigate();
    const feature = useFeature(() => new CheckingAccountFeature(application, navigator));
    /*const loadMore = () => {
        // TODO will history be paginated?
    };*/

    const renderItems = (feature) => {
        return feature.sortedAccountingDocuments().map((accountingDocument, index) => (
            <tr key={accountingDocument.id || index}>
                {/*<td>
                {accountingDocument.receiptFile ? (
                    <a href={accountingDocument.receiptFile}
                       target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faCopy} />
                    </a>
                ) : (
                    <a className="modalReclamo" href="#" data-toggle="modal" data-target="#modal-nuevo-reclamo">
                        <FontAwesomeIcon icon={faTimesCircle} />
                    </a>
                )}
            </td>*/}
                <td style={{ textAlign: 'left', color: 'black'}}>{feature.issueDate(accountingDocument)}</td>
                <td style={{ textAlign: 'left', color: 'black'}}>{feature.receiptName(accountingDocument)}</td>
                <td style={{ textAlign: 'left', color: 'black'}}>{feature.receiptNumber(accountingDocument)}</td>
                <td style={{ textAlign: 'left', color: 'black'}}>{feature.expirationDate(accountingDocument)}</td>
                <td style={{ textAlign: 'left', color: 'black'}}>
                    {MoneyRenderer(accountingDocument.isCredit ? -Math.abs(feature.balance(accountingDocument)) : feature.balance(accountingDocument))}
                </td>
            </tr>
        ));
    };

    // TODO: Update condition to hide or unhide 'under construction' message

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    if (!isFeatureReady(feature)) {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-sm-10 col-sm-offset-1">
                        <div className="text-center margintop60">
                            <Skeleton variant="text" width={200} height={40} />
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="container-info-pedido reclamo">
                                        <div className="row">
                                            <div className="col-sm-8">
                                                <div className="datos-pedido">
                                                    <div className="row datos-pedido-box">
                                                        <div className="col-xs-4 col-sm-3">
                                                            <Skeleton variant="text" width={120} />
                                                        </div>
                                                        <div className="col-xs-8 col-sm-9">
                                                            <Skeleton variant="text" width={150} />
                                                        </div>
                                                    </div>
                                                    <div className="row datos-pedido-box">
                                                        <div className="col-xs-4 col-sm-3">
                                                            <Skeleton variant="text" width={120} />
                                                        </div>
                                                        <div className="col-xs-8 col-sm-9">
                                                            <Skeleton variant="text" width={150} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="pedido-acciones">
                                                    <Skeleton variant="rectangular" width={150} height={40} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <hr className="margintop40"/>
                            <Skeleton variant="text" width={250} />
                            <Skeleton variant="text" width={250} />
                            <hr className="margintop30"/>

                            <div className="row">
                                <div className="col-sm-6">
                                    <Skeleton variant="text" width={200} />
                                </div>
                                <div className="col-sm-6">
                                    <Skeleton variant="text" width={200} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container">
            <div className="row">
                <div className="col-sm-10 col-sm-offset-1">
                    <div className="text-center margintop60">
                        <div className="text-center margintop30">
                            <div className="margintop60 hidden-xs"></div>
                            <h3>Cuenta Corriente</h3>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="container-info-pedido reclamo">
                                    <div className="row">
                                        <div className="col-sm-8">
                                            <div className="datos-pedido">
                                                <div className="row datos-pedido-box">
                                                    <div className="col-xs-4 col-sm-3">
                                                        <div className="item-box">
                                                            <p className="general-title text-right-left">Cliente</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-8 col-sm-9">
                                                        <div className="item-box">
                                                            <p className="descripcion-item-box">{feature.accountCustomerName()}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row datos-pedido-box">
                                                    <div className="col-xs-4 col-sm-3">
                                                        <div className="item-box">
                                                            <p className="general-title text-right-left">Razón
                                                                Social</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-8 col-sm-9">
                                                        <div className="item-box">
                                                            <p className="descripcion-item-box">{feature.accountBusinessName()}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="pedido-acciones">
                                                <a href={TICKETS_PATH}
                                                   className="btn btn-primary hidden-xs btn-add-reclamo">Informe
                                                    Pago</a>
                                                <div className="visible-xs">
                                                    <a href={TICKETS_PATH}
                                                       className="btn btn-primary btn-sm btn-add-reclamo">Informe
                                                        Pago</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr className="margintop40"/>

                        <div className="consolidado">
                            <p>{feature.consolidatedBalance()}</p>
                            <p className="title">Consolidado</p>
                        </div>

                        <hr className="margintop30"/>

                        <div className="row">
                            <div className="col-sm-4">
                                <div className="box-desglose text-center">
                                    <p>
                                        {feature.toOverdueBalance()}
                                    </p>
                                    <p className="title">A vencer</p>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="box-desglose text-center">
                                    <p className=" vencido">
                                        {feature.overdueBalance()}
                                    </p>
                                    <p className="title title-vencido">Vencido</p>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="box-desglose text-center">
                                    <p>
                                        {feature.unassignedBalance()}
                                    </p>
                                    <p className="title">Créditos sin asignar</p>
                                </div>
                            </div>
                        </div>
                        <hr/>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-cuenta">
                            <thead>
                            <tr>
                                {/*<th style={{textAlign: 'left'}}>Documento</th>*/}
                                <th style={{textAlign: 'left'}}>Fecha</th>
                                <th style={{textAlign: 'left'}}>Tipo</th>
                                <th style={{textAlign: 'left'}}>Número</th>
                                <th style={{textAlign: 'left'}}>Vto.</th>
                                <th style={{textAlign: 'left'}}>Importe</th>
                                {/*<th style={{textAlign: 'right'}}>Saldo</th>*/}
                            </tr>
                            </thead>
                            <tbody id="tbody">
                            {renderItems(feature)}
                            </tbody>
                        </table>
                    </div>

                    {/*<div className="row margintop60">
                        <div className="col-xs-12">
                            <div className="text-center">
                                <button id="verMas" className="btn btn-primary btn-lg" onClick={loadMore}
                                        disabled={feature.loading}>
                                    {feature.loading ?
                                        <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i> : 'Ver Más'}
                                </button>
                            </div>
                        </div>
                    </div>*/}

                    <div className="paddingtop20">
                        <p className="font12">La actualización de la información puede demorar hasta 48 Hs hábiles.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default observer(CheckingAccountScreen);
